<!--  -->
<template>
  <div>
    <v-row dense>
      <v-col sm="3" xl="3" md="3" lg="3" class="flex-justify-end flex-center">
        项目列表&查询条件是否显示项目编号：
      </v-col>
      <v-col sm="7" xl="7" md="7" lg="7">
        <form-item
          v-model="params.SHOW_PROJECT_CODE"
          class="flex-0 flex-shrink-0"
          :options="[
            { text: '是', value: '1' },
            { text: '否', value: '0' },
          ]"
          style="width: 250px"
          dense
          type="radio"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="3" xl="3" md="3" lg="3" class="flex-justify-end flex-center">
        是否显示项目经理：
      </v-col>
      <v-col sm="7" xl="7" md="7" lg="7">
        <form-item
          v-model="params.SHOW_PROJECT_MANAGER"
          class="flex-0 flex-shrink-0"
          :options="[
            { text: '是', value: '1' },
            { text: '否', value: '0' },
          ]"
          style="width: 250px"
          dense
          type="radio"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="3" xl="3" md="3" lg="3" class="flex-justify-end flex-center">
        是否显示CRO：
      </v-col>
      <v-col sm="7" xl="7" md="7" lg="7">
        <form-item
          v-model="params.SHOW_CRO"
          class="flex-0 flex-shrink-0"
          :options="[
            { text: '是', value: '1' },
            { text: '否', value: '0' },
          ]"
          style="width: 250px"
          dense
          type="radio"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="3" xl="3" md="3" lg="3" class="flex-justify-end flex-center">
        是否显示客户全称：
      </v-col>
      <v-col sm="7" xl="7" md="7" lg="7">
        <form-item
          v-model="params.SHOW_CUSTOM_NAME"
          class="flex-0 flex-shrink-0"
          :options="[
            { text: '是', value: '1' },
            { text: '否', value: '0' },
          ]"
          style="width: 250px"
          dense
          type="radio"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3" xl="3" md="3" lg="3" />
      <v-col sm="7" xl="7" md="7" lg="7">
        <v-btn
          small
          color="primary"
          depressed
          min-width="120"
          class="mr-2"
          height="30"
          style="padding: 0 8px"
          @click="saveSetting"
        >保存</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      params: {
        SHOW_PROJECT_CODE: undefined, // 项目列表&查询条件是否显示“项目编号：0否；1是
        SHOW_PROJECT_MANAGER: undefined, // "是否显示“项目经理：：0否；1是"
        SHOW_CRO: undefined, // "是否显示“CRO：：0否；1是"
        SHOW_CUSTOM_NAME: undefined, // "是否显示“客户全称：：0否；1是"
      },
      btnLoading: false,
    };
  },
  mounted() {
    this.getSetting();
  },
  methods: {
    getSetting() {
      this.$http
        .post(this.$api.getProjectListSetting, {
          data: {},
          type: 'application/x-www-form-urlencoded',
        })
        .then((res) => {
          console.log('获取', res);
          this.params = res.result;
        });
    },
    saveSetting() {
      this.btnLoading = true;
      this.$http
        .post(this.$api.saveProjectListSetting, {
          data: this.params,
        })
        .then((res) => {
          console.log('保存', res);
          this.$message.success(res.result || res.message);
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="" scoped></style>
